
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 lg:py-32 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/5e010b729e45f6517788780872116a49.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-blue-900/60"></div>
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
              Grow Your <span className="text-blue-200">Concierge</span> or <span className="text-blue-200">DPC Practice</span> with Qualified Patient Leads
            </h1>
            <p className="text-xl text-gray-100 mb-6 leading-relaxed drop-shadow-md">
              Connect with patients who are actively seeking personalized healthcare. We generate qualified leads for concierge and direct primary care practices across the United States.
            </p>
            
            <div className="bg-orange-500/90 backdrop-blur-sm border border-orange-300/50 rounded-lg p-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center">
                  <i className="ri-facebook-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-navy-900 font-medium">
                    Follow our Facebook page to see verified patient leads in real time
                  </p>
                  <a 
                    href="https://www.facebook.com/profile.php?id=61581793401421" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-navy-800 hover:text-navy-900 transition-colors cursor-pointer underline text-sm font-medium"
                  >
                    View live patient leads →
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
              >
                Start Growing Today
              </button>
              <button 
                onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
              >
                Learn How It Works
              </button>
            </div>
            <div className="mt-8 flex items-center space-x-6">
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-green-400 text-xl"></i>
                <span className="text-gray-100">Performance-Based Pricing</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-green-400 text-xl"></i>
                <span className="text-gray-100">Nationwide Coverage</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
